<template>
  <!--
    position="right" combined with full-height on the card
    perfectly mimics a mobile side-drawer!
  -->
  <q-dialog
    v-model="isOpen"
    position="right"
    transition-show="slide-left"
    transition-hide="slide-right"
  >
    <q-card style="width: 320px; max-width: 85vw" class="column full-height bg-white">
      <!-- Drawer Header -->
      <q-toolbar class="bg-primary text-white shrink shadow-2">
        <q-toolbar-title class="text-subtitle1 text-weight-bold">
          {{ menuTitle }}
        </q-toolbar-title>
        <q-btn flat round dense icon="close" v-close-popup />
      </q-toolbar>

      <!-- Scrollable List of Options passed via props -->
      <q-scroll-area class="col-grow">
        <q-list separator class="q-py-sm">
          <q-item
            v-for="opt in options"
            :key="opt.value"
            clickable
            v-ripple
            @click="selectOption(opt.value)"
          >
            <q-item-section>
              <q-item-label class="text-weight-medium text-grey-9">
                {{ opt.label }}
              </q-item-label>
              <q-item-label caption class="text-secondary text-weight-bold">
                Code: {{ opt.value }}
              </q-item-label>
            </q-item-section>

            <q-item-section side>
              <q-icon name="chevron_right" size="xs" color="grey-4" />
            </q-item-section>
          </q-item>
        </q-list>
      </q-scroll-area>
    </q-card>
  </q-dialog>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  modelValue: boolean
  title: string
  options: { label: string; value: string }[]
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
  (e: 'select', value: string): void
}>()

const menuTitle = computed(() => props.title || 'Advanced Options')

// Bi-directional binding for the dialog toggle
const isOpen = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val),
})

function selectOption(value: string) {
  emit('select', value)
}
</script>
